export default __webpack_public_path__ + "text-security-disc.b9b6048a31de4eed195f.woff2";